import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReimbursementList from "../../components/Reimbursement/ReimbursementList";

/**
 * Reimbursement V1 Page (Read-only)
 * This page displays historical reimbursement requests in read-only mode.
 * New requests should be submitted using the Reimbursement V2 page.
 */
const ReimbursementPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h5">{t("reimbursements.title")}</Typography>
      </Box>

      <Alert severity="info" sx={{ mb: 2 }}>
        {t("reimbursements.readOnlyMessage")}
      </Alert>

      <ReimbursementList trigger={false} />
    </Box>
  );
};

export default ReimbursementPage;
